import Axios from 'axios';
import Qs from 'qs';

export default {

  // 积分规则分页列表
  listPage(
    name,
    cycle,
    state,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/integrals', {
      params: {
        name,
        cycle,
        state,
        page,
        limit,
        sort: {
          id: 'desc'
        }
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 修改积分规则
  edit(
    id,
    cycle,
    max_astrict,
    score
  ) {
    return Axios.patch(`/community/api/admin/integrals/${id}`, {
      cycle,
      max_astrict,
      score
    });
  },

  // 启用积分规则
  enable(
    id
  ) {
    return Axios.patch(`/community/api/admin/integrals/start-or-stop/${id}`, {
      state: 1
    });
  },

  // 禁用积分规则
  disable(
    id
  ) {
    return Axios.patch(`/community/api/admin/integrals/start-or-stop/${id}`, {
      state: 0
    });
  },


}